export function cadastroUsuarioMasterInRequest(params = {}) {
  return {
    type: '@cadastrousuariomaster/CADASTROUSUARIOMASTER_IN_REQUEST',
    payload: { params },
  };
}

export function findCadastroUsuarioMaster(usua_login) {
  return {
    type: '@cadastrousuariomaster/FIND_CADASTROUSUARIOMASTER',
    payload: { usua_login },
  };
}

export function failedRequest() {
  return {
    type: '@cadastrousuariomaster/FAILED_REQUEST',
  };
}

export function deleteCadastroUsuarioMaster(usua_login, params) {
  return {
    type: '@cadastrousuariomaster/DELETE_CADASTROUSUARIOMASTER',
    payload: { usua_login, params },
  };
}

export function updateCadastroUsuarioMaster(usuarioMasterVO, params) {
  return {
    type: '@cadastrousuariomaster/UPDATE_CADASTROUSUARIOMASTER',
    payload: { usuarioMasterVO, params },
  };
}

export function storeCadastroUsuarioMaster(usuarioMasterVO, params) {
  return {
    type: '@cadastrousuariomaster/STORE_CADASTROUSUARIOMASTER',
    payload: { usuarioMasterVO, params },
  };
}

export function unblockUsuarioMaster(usua_login, params) {
  return {
    type: '@cadastrousuariomaster/UNBLOCK_CADASTROUSUARIOMASTER',
    payload: { usua_login, params },
  };
}

export function successInRequest(
  cadastrousuariomaster,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@cadastrousuariomaster/SUCCESS_IN_REQUEST',
    payload: { cadastrousuariomaster, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(usuarioMasterVO) {
  return {
    type: '@cadastrousuariomaster/SUCCESS_REQUEST',
    payload: { usuarioMasterVO },
  };
}

export function successRemove(params) {
  return {
    type: '@cadastrousuariomaster/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cadastrousuariomaster/RECORD_FILTERING',
    payload: { params },
  };
}

export function cleanErrors() {
  return {
    type: '@cadastrousuariomaster/CLEAN_ERRORS'
  }
}
